<template>
  <div id="app" :class="`appsize-${$mq}`">
    <main-app v-if="isLoggedIn"></main-app>
    <div id="loginwrap" v-if="!isLoggedIn">
      <login></login>
    </div>
  </div>
</template>

<script>
import Login from '@/components/login';
import { EventBus } from '@/event-bus';
import './custom.scss';
import axios from 'axios';
import libmime from 'libmime';
import LoadingMainApp from '@/components/loadingMainApp';
import ErrorMainApp from '@/components/errorMainApp';
const MainApp = () => ({
  component: import(/* webpackChunkName: "mainApp" */'@/components/mainApp'),
  loading: LoadingMainApp,
  error: ErrorMainApp,
  delay: 0,
  timeout: 10 * 60 * 1000
});

export default {
  name: 'App',
  components: { MainApp, Login },
  data: function() {
    return {
      keepAliveCounter: 0,
      keepAlive: 1,
      interval: null
    };
  },
  watch: {
    foldersLoaded() {
      if (this.$router.currentRoute.name === 'loading') {
        this.$router.push(`/n/${this.$store.getters.getFolderByName('Inbox').id}/1`);
      }
    }
  },
  created() {
    EventBus.$on('login', () => {
      console.log('Login Eventbus');
      this.$store.dispatch('getFolders');
      this.$store.dispatch('getSettings');
      this.$store.dispatch('getCollectedAddresses');
      this.$store.dispatch('getAddressBook');

      this.startWebsocket();
      axios.get('https://www.pscs.co.uk/webmailinit', { params: {
        guid: localStorage.getItem('serverGuid'),
        auth: localStorage.getItem('token'),
        build: localStorage.getItem('serverbuild')
      } })
        .then(d => {
          this.$store.dispatch('enableSentry', !!d.data.sentry);
          this.$store.dispatch('enableLogRocket', !!d.data.logrocket);
          this.$store.dispatch('enableInternalTrack', !!d.data.internal);
          // this.$store.dispatch('enableSmartLook', !!d.data.smartlook);
        });
    });

    EventBus.$on('logout', () => {
      console.log('Logout Eventbus');
      this.closeWebsocket();
    });

    EventBus.$on('messageDelivery', msg => {
      if (document.visibilityState === 'visible') {
        this.$snotify.info(this.$t('notifications.newMessage', { subject: libmime.decodeWords(msg.subject),
          senderName: libmime.decodeWords(msg.fromName),
          senderAddr: msg.fromAddr,
          size: msg.size
        }))
          .on('click', toast => {
            this.$router.push(`/n/${msg.folder}/1`);
          });
      }
    });

    if (this.$store.getters.isLoggedIn) {
      this.$store.commit('loginSuccess');
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.keepAliveCounter++;
        if (this.keepAliveCounter >= this.keepAlive) {
          axios
            .get('/rest/user/updates')
            .then(d => {
            })
            .catch(e => {
              console.log('Keepalive failed - go to login', e);
              this.$store.dispatch('logout', 'Keepalive failed');
            });
        }
      } else {
        this.keepAliveCounter = 0;
      }
    }, 30000);
  },
  methods: {
    startWebsocket() {
      console.log('Websocket connect', localStorage.getItem('wsserver'));
      this.$connect(localStorage.getItem('wsserver') + '/websocketuser?auth=' + localStorage.getItem('token'));
    },
    closeWebsocket() {
      this.$disconnect();
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    foldersLoaded() {
      return this.$store.state.foldersLoaded;
    }
  }
};

</script>
<style lang="scss">
$animationDuration: 0.5s; // specify animation duration. Default value: 1s
@import '../node_modules/vue2-animate/src/sass/vue2-animate.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  font-family: Verdana, Helvetica, Arial, sans-serif;
}
#mainwrap {
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 40px calc(100vh - 40px);
  grid-template-areas: "topbar" "bottom";

  #topbar {
    // height: 40px;
    grid-area: topbar;
  }

  #bottom {
    grid-area: bottom;
    overflow: hidden;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
